export const TranslationsEN = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
    },
    // BASE
    phrases: {
        order_online: 'Order Online',
        cart: 'Cart',
        open_24: '24 Hours',
        closed: 'Closed',
        free: 'FREE',
        something_went_wrong: 'something went wrong',
        try_again: 'try again',
    },
    constants: {
        calendar: {
            days: {
                monday: 'Monday',
                tuesday: 'Tuesday',
                wednesday: 'Wednesday',
                thursday: 'Thursday',
                friday: 'Friday',
                saturday: 'Saturday',
                sunday: 'Sunday',
            },
        },
        services: {
            pickup: 'Pickup',
            delivery: 'Delivery',
            dine_in: 'Dine-In',
            table_booking: 'Table Booking',
        },
        payment: {
            method: {
                cash: 'Cash',
                card: 'Card',
                stripe: 'Credit Card',
                paypal: 'PayPal',
                cardconnect: 'Credit Card',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                razor_pay: 'Razor Pay',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                custom: 'Custom',
                red_dot: 'Red Dot Payment',
                gkash: 'Gkash',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Wallet',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                authorized: 'Authorize.net'
            },
            // BACKENDMETHODNAMES
            backend_method: {
                cash: 'Cash',
                card: 'Card',
                stripe: 'Stripe',
                paypal: 'PayPal',
                cardconnect: 'CardConnect',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                bambora_na: 'Worldline',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                stripe_digital_wallet: 'Google/Apple Pay',
                razor_pay: 'Razor Pay',
                gravity: 'Gravity',
                authorized: 'Authorize.net',
                elavon: 'Elavon',
                red_dot: 'Red Dot Payment',
                gkash: 'Gkash',
                custom: 'Custom',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Wallet',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                nuvei: 'Nuvei',
                ONLINE: 'Online',
                online: 'Online'
            },
            status: {
                success: 'Success',
                pending: 'Pending',
                error: 'Error',
                refunded: 'Refunded',
                refunding: 'Refunding',
                partial_refunded: 'Partially Refunded',
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: 'Remove',
                drop_here: 'Drop your files here or click to select one',
                accepts: 'Accepts {{fileTypes}} files',
                errors: {
                    max_files: 'Maximum of {{number}} allowed',
                    max_size: 'Max file size of {{kilobytes}} KB',
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: 'The store is currently closed and a dine-in order due immediately cannot be placed. You can try order for a later date and time instead',
            },
            buttons: {
                order: {
                    book_order: 'Book Table / Order Online',
                    order_online: 'Order Online',
                    book_table: 'Book A Table',
                    order: 'Order',
                    book: 'Book',
                    cart: 'Cart',
                    restart: 'Restart',
                    closed: 'Store Closed',
                    not_accepting: 'Not Accepting Orders',
                },
            },
        },
        modals: {
            auth: {
                login: 'Login',
                register: 'Register',
                register_commence: 'Continue',
                register_complete: 'Create Account',
                register_confirmation_sent: 'A confirmation code has been sent to your e-mail address. Please enter it below to proceed',
                register_confirmation_resent: 'The confirmation code has been sent again, check your spam or restart the process',
                register_restart: 'Restart',
                register_resend_code: 'Re-send code',
                register_confirmation_code_subject: 'E-Mail Confirmation Code',
                register_confirmation_code_email: 'Your email confirmation code is {{confirmation_code}} (Expires in 24 hours)',
                login_placeholder: 'E-mail',
                password_placeholder: 'Password',
                confirm_password_placeholder: 'Confirm Password',
                confirmation_code_placeholder: 'E-Mail Confirmation Code',
                accept_terms: 'Accept Terms & Conditions',
                accept_terms_view: 'View',
                login_facebook: 'Login With Facebook',
                login_google: 'Login With Google',
                benefits: 'Login or create an account to save all your orders',
                logged_in: 'Successfully Logged In',
                logged_out: 'Logged Out',
                password_reset: {
                    init_button: 'Send Password Reset Mail',
                    init_success: 'Password reset link has been sent to your e-mail',
                    complete_button: 'Reset Password',
                    complete_success: 'Password successfully reset, login with your new password',
                    forgot_password_text: 'Forgotten your password? ',
                    forgot_password_link: 'Reset password',
                    remember_password_text: 'Remember your password? ',
                    remember_password_link: 'Go back',
                    invalid_title: 'Password Reset Invalid',
                    invalid_description: 'This password reset link is not valid, request a new one instead',
                    invalid_link: 'Go To Login',
                    title: 'Password Reset',
                    description: 'Enter a new password for your account',
                },
                error_generic: 'Something went wrong, please try again or contact us',
                error_accept_terms: 'Please accept the terms & conditions',
                error_password_length: 'Minimum of 6 characters for password',
                error_social: 'Something went wrong, try again or contact us',
                error_confirmation_code: 'Invalid confirmation code',
                error_invalid_code: 'Invalid confirmation code',
                error_exists: 'User already already exists',
                error_invalid_email_pass: 'Invalid e-mail address or password',
                error_password_no_match: 'Passwords do not match each other',
                error_user_not_found: 'No user with that e-mail address',
                error_invalid_email: 'Invalid e-mail address',
                error_invalid_reset_token: 'Invalid reset link, request another one',
            },
            booking: {
                form: {
                    name: 'Full Name',
                    email: 'E-Mail Address',
                    phone: 'Phone Number',
                    number_of_people: 'Number Of People',
                    number_of_people_max: 'Number Of People ({{max_people}} Max)',
                    number_of_people_min: 'Number Of People ({{min_people}} Min)',
                    number_of_people_max_min: 'Number Of People (Between {{min_people}} to {{max_people}})',
                    number_of_guests: 'Number of Guests',
                    notes: 'Notes / Special Requests',
                    submit: 'Submit Booking Request',
                    info_1: 'You will receive an e-mail notification when your booking is accepted or denied',
                },
                errors: {
                    not_found: "Booking doesn't exist. It was possibly deleted",
                    generic: 'Something went wrong, refresh the page or contact us',
                    something_went_wrong: 'Something went wrong',
                    accept_terms: 'Please accept the terms & conditions',
                    required_phone: 'Please enter your phone number',
                    required_email: 'Please enter your email',
                    required_zip: 'Please enter your billing zip code',
                    required_name: 'Please enter your name',
                    invalid_email: 'Please enter a valid e-mail address',
                    invalid_phone: 'Please enter a valid phone number',
                    invalid_people: 'Invalid number of people',
                    missing_custom_fields: 'Please fill in all required fields.',
                },
            },
            cart: {
                title: 'Cart',
                proceed_to_checkout: 'Proceed To Checkout',
                edit_dish: 'Edit',
                remove_dish: 'Remove',
                no_items_1: 'No items in cart',
                no_items_2: 'Add some first to proceed',
                free_delivery_notice: 'Free delivery for orders over {{value, currency}}',
                errors: {
                    min_order_promo: 'Minimum cart value of {{value, currency}} required before this promo is applied',
                    min_order_delivery: 'Minimum cart value of {{value, currency}} for delivery',
                },
                promo: {
                    heading: 'Promo Code',
                    placeholder: 'Enter your promo code',
                    add: 'Add Code',
                    title: 'Promo {{name}} added to cart',
                    fixed_discount: '{{value, currency}} Off',
                    percent_discount: '{{value}}% Off',
                    added_to_cart: 'Promo added to cart',
                    errors: {
                        not_found: 'Promo not found',
                        disabled: 'Promo is disabled',
                        not_available: 'Promo is currently not available',
                        not_eligible: 'Not eligible to apply promotional code',
                        not_available_time: 'Promo does not apply for this time',
                        logged_in_only: 'Must be logged in to use this promo',
                        already_used: 'You have already used this promo',
                        invalid: 'This promo is no longer valid',
                        invalid_service: 'This promo is not valid for your chosen service',
                        later_only: 'Valid for pre-orders only',
                        now_only: 'Valid only for orders due immediately not pre-orders',
                        generic: 'Oops... something went wrong and has been logged',
                        dishes_required_multi: 'This promo will only be applied when certain items are added to your cart',
                        dishes_required_single: "This promo will only be applied for '{{dish}}'",
                    },
                },
                tip: {
                    title: 'Order Tip',
                    placeholder: 'Add an order tip',
                },
            },
            free_items_promo: {
                title: 'Free Items',
                usage_confirmation: {
                    question: 'You are eligible for free items. Would you like to see and add them?',
                    cancellation: "No, I don't want free items",
                    acceptance: 'Yes',
                },
                free_items_selection: {
                    multiple: {
                        description: 'Select {{number}} free item(s)',
                    },
                    single: {
                        description: 'Select a free item',
                    },
                    confirm_button: 'Confirm',
                },
            },
            checkout: {
                title: 'Checkout',
                subtitle: 'Confirm your order details',
                details: {
                    service: 'Service',
                    due: 'Due',
                    due_now_asap: 'Now / ASAP',
                    address: 'Delivery Address',
                    total: 'Total',
                    table: 'Table',
                    store_location: 'Store Address',
                },
                customer: {
                    title: 'Customer',
                    subtitle: 'Login to save your order & details',
                    button: 'Login',
                    name: 'Full Name',
                    email: 'Email',
                    phone: 'Phone',
                    phone_important: 'Phone (Important)',
                    notes: 'Order Notes',
                    delivery_notes: 'Delivery Instructions / Order Notes',
                    optional: 'optional',
                },
                payment: {
                    title: 'Payment Method',
                    qr_modal_help: 'Use your {{app}} mobile application to scan the QR and complete the payment for this order. Once the payment was completed on your mobile application, you can close this QR modal. Please do not close this QR modal if you have not finished your payment process.',
                    switch_to_app_help: 'By pressing below button, {{app}} mobile application will be opened automatically to complete the payment for this order. Once the payment was completed on your mobile application, you can close this modal. Please do not close this modal if you have not finished your payment process.',
                    open_app: 'Open {{app}} Application',
                    continue: 'Continue',
                    continue_to_payment: 'Continue to {{method}}',
                    back_to_cart: 'Back to Cart',
                },
                accept_terms: 'Accept Terms & Conditions',
                accept_terms_view: 'View',
                processing_order: 'Processing Order',
                warning: {
                    different_payment_currency: 'Store prices are in {{store_currency}} but payment method is in {{payment_currency}}',
                    closing_soon: 'Closing soon, orders must be placed within {{value}} minutes',
                    closed: 'Sorry, this service has closed and orders are not being accepted',
                    paused: 'Sorry, this service has been paused and orders are not being accepted as of the moment',
                    expired: 'We can no longer fulfill your order at your selected time. Please choose a later date or time',
                },
                errors: {
                    walletly_promo: 'Walletly promo has error, please try another promo!',
                    stripe_generic: 'Credit card error, try again or another method',
                    validation_failed: 'This payment cannot be accepted at this time. Please try again later or choose another payment method.',
                    validation_failed_recaptcha_v3: 'Unusual traffic detected. Are you using VPN? Please complete the challenge above and try again.',
                    validation_failed_recaptcha_v2: 'We couldn\’t initiate the payment. Please try again or use another method. If you\'re using a VPN, try turning it off first.',
                    stripe_loading_fail: 'Error loading payment form, please try again',
                    something_went_wrong: 'Something went wrong',
                    paypal_generic: 'Something went wrong with PayPal, try again or pick another payment method',
                    payment_fail: 'Payment failed, please try again or select another payment method',
                    payment_cancelled: 'Payment cancelled, please try again or select another payment method',
                    payment_error: 'Error processing online payment, try again or pick another payment method',
                    payment_declined: 'Your payment method was declined',
                    card_declined: "Your card was declined and payment couldn't be processed",
                    store_closed: 'The store is closed and no longer accepting orders',
                    accept_terms: 'Please accept the terms & conditions',
                    required_payment: 'Please select a payment method',
                    required_phone: 'Please enter your phone number',
                    required_email: 'Please enter your email',
                    required_zip: 'Please enter your billing zip code',
                    required_name: 'Please enter your name',
                    invalid_email: 'Please enter a valid e-mail address',
                    invalid_phone: 'Please enter a valid phone number',
                    invalid_cc_number: 'Your credit card number is invalid',
                    invalid_order_amount: 'Minimum amount required for this payment method',
                    retry_cc_number: 'Something went wrong, re-enter your credit card number and try again',
                    closed: 'The store is closed and not accepting orders',
                    promo_login_required: 'Must be logged in to use this promo',
                    promo_used: 'You have already used this promo',
                    promo_by_payment_method_not_applicable: 'Promo is not applicable to the selected payment method.',
                    missing_custom_checkout_fields: 'Please fill in all required fields.',
                    delivery_unavailable: 'Delivery service may not be available at this time. Please consider doing a Pick Up order instead.',
                    required_delivery_provider: 'Please choose a service delivery.',
                    required_delivery_quotation: 'Delivery estimation expired.',
                    exceeded_order_limit: 'We’re getting a lot of orders at the moment. Please choose a later time.',
                    exceeded_order_limit_later: 'We can no longer fulfill your order at your selected time. Please choose a later date or time',
                },
                button: {
                    continue: 'Continue To Payment',
                    place_order: 'Place Order',
                    update_order: 'Update Order',
                },
                delivery_estimation: {
                    title: 'Delivery Estimation',
                    details: {
                        provider: 'Delivery Provider',
                        estimated_fee: 'Estimated Fee',
                        previous_estimated_fee: 'Previous Estimated Fee',
                        tips: 'Tips',
                        estimated_delivery_time: 'Estimated Delivery Time',
                        uber_new_estimation: 'Request new estimate',
                        uber_new_estimation_success: 'New Uber Delivery Estimation applied.',
                        uber_estimation_expired: 'Delivery estimation expired',
                        uber_price: 'We are holding Uber price',
                        uber_need_time: 'I need more time',
                        lalamove_price: 'We are holding Lalamove delivery fee',
                        lalamove_new_estimation_success: 'New Lalalmove Delivery Estimation applied.',
                        lalamove_estimation_expired: 'Delivery estimation expired',
                        lalamove_need_time: 'I need more time',
                        lalamove_new_estimation: 'Request new estimate',
                    },
                    quotation_error: 'Something went wrong calculating delivery estimation.',
                },
            },
            customer: {
                age_v: {
                    title: 'Age Verification',
                    required_for_items: 'Required to order certain items',
                    min_age: 'Minimum age: {{age}} years',
                    est_time: 'Estimated verification time: {{time}} hours',
                    upload_description: 'Upload your ID below for verification. You will be notified via e-mail once verified. Upload up to 2 images with a maximum size of 2 MB each',
                    pending_description_1: 'Thank you for submitting your documents. You will be notified via e-mail when you are approved',
                    pending_description_2: 'Refresh the page to update your verification status. Estimated verification time is {{time}} hours',
                    approved_description: 'Your account has been verified and you can order from restricted menus',
                    rejected_description: 'Your ID has been rejected. If you wish to try again, please re-upload your ID',
                    upload: 'Upload',
                    reupload: 'Re-Upload Documents',
                    go_back: 'Go Back',
                    view_document: 'View Document {{number}}',
                    status: {
                        unverified: 'Un-verified',
                        pending: 'Waiting For Approval',
                        approved: 'Successfully Verified',
                        rejected: 'Rejected',
                    },
                },
                headings: {
                    sessions: 'Sessions',
                    orders: 'Order',
                    spend: 'Spend',
                    order_history: 'Order History',
                    loyalty: 'Loyalty',
                    loyalty_points: 'Loyalty Points',
                    added: 'Promo added.',
                },
                loyalty_errors: {
                    invalid_cart_items: 'Please choose any item before redeem!',
                    not_found: 'Promo not found !',
                    already_exists: 'Promo already exists!',
                    try_again: 'Cannot apply this deal. Please try again!',
                },
            },
            custom_payment: {
                title: '{{name}} Payment Form',
                description: 'You have reached our online payment form. Please complete the fields below to make a payment. If an amount is not entered, your details will be saved but you will not be charged.',
                disabled: 'This online payment page has not been configured correctly. Please contact the site owner to rectify the issue.',
                success: 'Your payment was successfully processed and your details have been saved. Thank you',
                back: 'Back To Home',
                fields: {
                    name: 'Full Name',
                    email: 'E-mail Address',
                    reference: 'Payment Ref.',
                    amount: 'Amount ($)',
                    name_on_card: 'Name On Card',
                    submit: 'Submit Payment',
                },
                warning: {
                    currency: 'Note: Payment amount in {{actual}}, not {{default}}',
                },
                errors: {
                    generic: 'Something went wrong, try again or contact us',
                    stripe_generic: 'Credit card error, refresh the page and try again',
                    payment_fail: 'Payment failed, please try again or select another payment method',
                    payment_cancelled: 'Payment cancelled, please try again or select another payment method',
                    payment_error: 'Error processing online payment, try again or pick another payment method',
                    payment_declined: 'Your payment method was declined',
                    card_declined: "Your card was declined and payment couldn't be processed",
                },
            },
            dish: {
                add: 'Add To Cart',
                edit: 'Update Item',
                notes: 'Special instructions...',
                ingredients: {
                    title: 'Ingredients',
                    uncheck_remove: 'Un-check to remove',
                },
                ingredients_title: 'Ingredients',
                combo: {
                    choose_dish: 'Choose A Item',
                },
                option_sets: {
                    conditions: {
                        select_one: 'Select one (Required)',
                        select_one_optional: 'Select one (Optional)',
                        select_between: 'Select between {{min}} - {{max}} (Required)',
                        select_at_least: 'Select at least {{qty}} (Required)',
                        select_up_to: 'Select up to {{qty}} (Optional)',
                        select_multiple_optional: 'Select multiple (Optional)',
                        select_multiple: 'Select multiple (Required)',
                        free_amount: 'First {{qty}} Free / {{selected}} Chosen',
                    },
                    points: {
                        none_consumed: 'You can pick maximum of {{maxFree}} options for free',
                        less_than_total_points: 'You may pick more options for free',
                        greather_than_total_points: 'You may pick more options for additional charge',
                    },
                },
                error: 'Please correct any options marked in red',
                added_to_cart: 'Item Added To Cart',
            },
            map: {
                zone_fee: 'Delivery Fee',
                view_in_google: 'View In Google Maps',
            },
            portal_go_back: {
                title: 'Go Back To Restaurant Search?',
                description: 'Any items in your cart will be lost',
                cancel: 'Cancel',
                proceed: 'Go Back',
            },
            order: {
                config: {
                    services: {
                        title: 'Choose A Service',
                        table_booking: 'Book Table',
                    },
                    address_custom: {
                        input_placeholder: 'Enter your address',
                    },
                    address: {
                        input_placeholder: 'Find Your Delivery Address',
                        extras_placeholder: 'Unit number, building name, delivery instructions, etc...',
                        search_placeholder: 'Search For Your Address',
                        search_input_placeholder: 'Type to search',
                        no_address_found: 'No addresses found. Try typing more than 5 characters',
                        not_found: 'Delivery address not found or valid, try again',
                        not_delivering: 'We are currently not delivering to this address',
                        not_in_range: 'Your address is not in range of our store location',
                        not_in_zone: 'Your address is not within an active delivery zone',
                        no_number: 'Your address must have a street number',
                        location_permission: 'Allow this website to access your current location?',
                        location_permission_warning: "Cannot access your current location. Please enable location service on your device and web browser. Here're some references:",
                        pick_location: 'Pick Your Location',
                        pick_location_help_text: 'Drag the marker to choose location on the map.',
                        use_current_location: 'Use Current Location',
                        locate_on_map: 'Locate on Map',
                    },
                    datetime: {
                        title: 'When Would You Like Your Order',
                        due_now: 'Now',
                        due_later: 'Later',
                        service_not_available: 'Sorry, we are currently not accepting orders for {{service}}',
                        currently_closed: '{{service}} currently closed but you can order for later',
                        due_unavailable: 'Unavailable',
                        due_closed: 'Closed',
                        select_date: 'Select Date',
                        select_time: 'Select Time',
                        select_order_date: 'Select Your Order Date',
                        select_order_time: 'Select Your Order Time',
                        select_order_date_time: 'Select Your Order Date/Time',
                        select_booking_date: 'Select Your Booking Date',
                        select_booking_time: 'Select Your Booking Time',
                        no_times_available: 'No times available to choose from',
                        date_today: '(Today)',
                        date_closed: '(Closed)',
                        time_slot_closed: 'Closed',
                    },
                    number_of_people: {
                        placeholder: 'Number Of People',
                    },
                    table: {
                        select: 'Select Table',
                        select_popup_title: 'Select Your Table',
                        password: 'Table Password',
                        password_warning: 'Enter your table password to proceed',
                    },
                    warning: {
                        closed: 'Sorry, we are currently closed / not accepting any orders',
                        not_available: 'Sorry, we are currently not accepting any orders',
                    },
                    eta: {
                        delivery: `Estimated delivery time is approx {{minutesToCustomer}} minutes`,
                        pickup: `Order will be ready in approx {{minutesToCustomer}} minutes`,
                    },
                    start_button: 'Start Order',
                },
                history: {
                    invalid: 'Not eligible for re-order as some of the items ordered have been modified or are no longer available',
                },
                reorder: {
                    title: 'Quick Re-Order',
                    description: 'Easily order the items from your previous orders',
                },
            },
            receipt: {
                errors: {
                    not_found: 'Order not found, refresh the page and try again',
                    generic: 'Something went wrong, refresh the page or contact us',
                },
                connection: {
                    connected: 'Real-time updates',
                    connecting: 'Real-time updates connecting',
                    disconnected: 'Real-time updates disconnected',
                },
            },
            warnings: {
                logout: {
                    pretitle: 'Warning',
                    title: 'Logout',
                    body: 'Logging out will remove any items that have been added to your cart',
                    cancel: 'Cancel',
                    proceed: 'Proceed',
                },
                order_restart: {
                    warning: 'Warning',
                    title: 'Change Order Details',
                    body: 'Changing your order details will remove the items in your cart as certain items may become unavailable',
                    cancel: 'Cancel',
                    proceed: 'Proceed',
                },
                order_expired: {
                    subtitle: 'Important',
                    title: 'Order changed to due immediately',
                    description: 'The time selected for you order is now not far off. As such your order has been modified to due immediately / ASAP',
                    button: 'Ok',
                },
                order_expiring: {
                    subtitle: 'Important',
                    title: 'Order Deadline Expiring Soon',
                    description: 'Your order must be placed before {{time, timeFromTimestamp}} otherwise it no longer be valid',
                    button: 'Ok',
                },
                location_permission: {
                    cancel: 'Cancel',
                    proceed: 'Proceed',
                },
            },
            card_payment_authentication: {
                title: 'Payment Authentication',
                note: 'Please keep this window open until you complete the authentication process from your bank.',
            },
            maps: {
                cancel: 'Cancel',
                use_location: 'Use Location',
            },
            app_refresh: {
                refresh: 'Refresh',
                title: 'Refresh Store',
                description: 'Our store has undergone an update. Kindly refresh your browser to access the most recent version. After refreshing, you may need to reopen your cart to proceed with the checkout process.',
            },
        },
        sections: {
            nav_top: {
                guest: 'Guest',
                login: 'Login',
                login_signup: 'Login / Sign Up',
                logout: 'Logout',
            },
            menus: {
                info: {
                    no_menus: 'There are currently no menus available',
                    restrictions: 'Menu Restrictions',
                    not_available: 'Menu Unavailable',
                    unavailable: {
                        times: "Menu unavailable, your order requirements don't match below",
                        services: "Menu unavailable, your order requirements don't match below",
                        hours: 'Menu unavailable, your order hours not within this menus available hours',
                        pre_order: "Menu unavailable, your order doesn't match the pre-order requirements",
                        age: 'Menu unavailable, you must be logged in with a age verified account to order from this menu',
                    },
                    services: {
                        title: 'Order Requirements',
                        pickup: 'Pickups',
                        delivery: 'Deliveries',
                        dine_in: 'Dine-Ins',
                    },
                    times: {
                        now: 'No pre-orders',
                        later: 'Pre-orders only',
                    },
                    hours: {
                        title: 'Available Hours',
                    },
                    preorder: {
                        title: 'Pre-Order Requirements',
                        days_in_advance: 'Must order {{days}} days in advance',
                        cutoff_time: 'Last day cut-off time at {{time, timeFromTime}}',
                    },
                    age_restricted: {
                        title: 'Age Restricted',
                        approved: 'Your account is verified and you can order from this menu',
                        rejected: 'Requires age verification to order. Create an account and upload your ID',
                    },
                },
                search: {
                    title: 'Explore Menu Items',
                    no_result: 'Nothing came back. Try another search term?',
                    placeholder: 'What are you looking for?',
                },
            },
            category: {
                restrictions: 'Category Restrictions',
                not_available: 'Category Unavailable',
                unavailable: {
                    services: "Category unavailable, your order requirements don't match below",
                    hours: "Category unavailable, your order hours not within this category's available hours",
                },
            },
            info: {
                location: {
                    title: 'Location',
                    view_map: 'View Map',
                    phone: 'Phone',
                },
                hours: {
                    title: 'Opening Hours',
                    title_special: 'Special Opening Hours',
                },
                services: {
                    title: 'Services',
                    notes: 'Notes',
                    delivery: {
                        ranges: 'Delivery Ranges',
                        zones: 'Delivery Zones',
                        view_zones: 'View Zones On Map',
                        fee: 'Delivery Fee',
                        fee_varies: 'Varies, shown in cart',
                        min_order: 'Minimum Order',
                        no_min_order: 'No Minimum Order',
                        free_amount: 'Free Delivery Amount',
                    },
                },
            },
            contact: {
                title: 'Contact Us',
                name: 'Name',
                email: 'E-mail',
                phone: 'Phone Number',
                message: 'Enter your message...',
                send: 'Send Message',
                success: 'Your message has been successfully sent',
                error: 'Something went wrong, try again or at a later time',
            },
            footer: {
                powered_by: 'Powered By',
                terms_and_conditions: 'Terms & Conditions',
                privacy: 'Privacy Policy',
                cookie: 'Cookie Policy',
            },
        },
        pages: {
            payment_completed: {
                title: 'Your payment was processed. Thank you for your order!',
                subtitle: 'The order information has been sent to your email address.',
                back_to_menu: 'Back to Menu',
                close_tab: 'Close this tab',
            },
            payment_failed: {
                title: 'Unfortunately there was an error while processing your payment.',
                subtitle: '',
                back_to_menu: 'Back to Menu',
                close_tab: 'Close this tab',
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'Booking Receipt',
            details: {
                datetime: 'Booking For',
                number_of_people: 'No. Of People',
                placed: 'Placed',
                updated: 'Last Updated',
                notes: 'Notes',
                name: 'Name',
                email: 'E-Mail',
                phone: 'Phone',
                store_address: 'Store Address',
            },
            status_update: {
                title: 'Booking {{number}} Updated',
                body: 'Your booking status has been updated to {{status}}',
            },
            email_common: {
                name: 'Name: {{name}}',
                phone: 'Phone: {{number}}',
                number_of_people: 'Number of Persons: {{number}}',
                date: 'Date: {{date}}',
                time: 'Time: {{time}}',
                location: 'Store Location: {{name}}',
                notes: 'Notes: {{name}}',
            },
            email_new_booking_restaurant: {
                subject: 'New Table Booking {{number}} By {{name}}',
                powered_by: 'Powered By {{name}}',
                overview: 'New Table Booking Request',
                title: 'New Booking For {{name}}',
                subtitle: 'Booking Number {{number}}',
                description_confirmed: 'The booking has be automatically confirmed. You can cancel it through the admin dashboard and your customer will be notified by email',
                description_unconfirmed: 'Please confirm or cancel the booking through the admin dashboard',
                url_pre_text: 'View and update at',
            },
            email_new_booking_customer: {
                subject: 'Table Booking Request',
                powered_by: 'Powered By {{name}}',
                overview: 'New Table Booking Request',
                title: 'Thank You For Your Booking',
                subtitle: 'Booking Number {{number}}',
                description: 'You will receive another email when your booking has been confirmed or rejected. Please contact us to make any changes to your booking. The details of your booking are as follows:',
                url_pre_text: 'You can view your real-time booking receipt at',
            },
            email_update_booking_customer: {
                subject_confirmed: 'Table Booking Confirmed',
                subject_unconfirmed: 'Table Booking Cancelled',
                powered_by: 'Powered By {{name}}',
                overview: 'Table Booking Request',
                title_confirmed: 'Booking Confirmed',
                title_unconfirmed: 'Booking Cancelled',
                subtitle: 'Booking Number {{number}}',
                description_confirmed: 'We look forward to seeing you. Please contact us to request any changes to your booking',
                description_unconfirmed: 'We regret to inform you that your booking request could not be accepted. We apologize for any inconvenience caused. Please contact us if you have any questions',
                url_pre_text: 'You can view your real-time booking receipt at',
            },
            errors: {},
            status_warning: 'Update the status of this booking in your admin dashboard in the bookings page',
        },
    },
    email_delayed_order: {
        subject: 'Order Change Notification',
        header: 'Order Change Notification',
        title: 'Order Change Notification',
        order_number: 'Order Number: {{number}}',
        description: 'Order Time Updated to: {{time}}',
        order_time_updated_to: 'Order Time Updated to: {{time}}',
        powered_by: 'Powered By {{name}}',
        button_text: 'Track Order',
    },
    order: {
        receipt: {
            est_ready_time: 'Est. Ready Time',
            est_driver_pickup_time: 'Est. Driver Pickup Time',
            est_delivery_time: 'Est. Delivery Time',
            tab_details: 'Details',
            tab_dishes: 'Items',
            future_order: 'Future Order',
            reprint: 'Reprint',
            details: {
                order_no: 'Order No.',
                status: 'Status',
                placed: 'Placed',
                due: 'Due',
                due_asap: 'Now / ASAP',
                last_updated: 'Last Updated',
                total: 'Total',
                type: 'Type',
                origin: 'Origin',
                table: 'Table',
                number_of_people: 'Number Of People',
                payment_method: 'Payment Method',
                payment_status: 'Payment Status',
                payment_currency: 'Payment Currency',
                notes: 'Notes',
                name: 'Name',
                email: 'E-Mail',
                phone: 'Phone',
                distance: 'Distance',
                driving_time: 'Driving Time',
                delivery_zone: 'Zone',
                delivery_address: 'Delivery Address',
                delivery_provider: 'Delivery Provider',
                delivery_tracking: 'Delivery Tracking',
                delivery_return_tracking: 'Track Return',
                delivery_tracking_link: 'Track Order',
                tookan_status: 'Tookan Status',
                tookan_status_failed_book: 'Failed to book delivery',
                tookan_status_failed_update: 'Failed to update booking',
                tookan_status_success: 'Booked for delivery',
                store_address: 'Store Address',
                destination: 'Destination',
                estimated_arrival_time: 'Estimate Arrival Time',
                delivery_status: 'Status',
                delivery_track_your_order: 'Track Your Order',
                delivery_text: 'Delivery',
                arrival_date: 'Arrival Date',
            },
            dishes: {
                headings: {
                    quantity: 'Qty',
                    item: 'Item',
                    price: 'Price',
                },
                notes: 'Notes',
                remove_ingredients: 'Remove Ingredients',
            },
            status_update: {
                title: 'Order {{number}} Updated',
                body: 'Your order status has been updated to {{status}}',
            },
            wait_time_update: {
                title: 'Order {{number}} Updated',
                body: 'Your order due time has been updated',
            },
            delivery_update: {
                title: 'Order {{number}} Updated',
                body: 'Your order has been booked for delivery. See real-time tracking link',
            },
            payment_status_update: {
                title: 'Order {{number}} Updated',
                body: 'Your order payment status has been updated.',
            },
            email_new_order_restaurant: {
                subject: 'New Order ({{number}}) - {{name}}',
                powered_by: 'Powered By {{name}}',
                overview: 'New Order Notification',
                title: 'New Order Placed At {{name}}',
                subtitle: 'Order Number {{number}}',
                description: 'View details and updates through your admin dashboard',
                button_text: 'Track Order',
                track_delivery_button_text: 'Track Delivery',
            },
            email_new_order_customer: {
                subject: 'Order Receipt ({{number}})',
                powered_by: 'Powered By {{name}}',
                overview: 'New Order Notification',
                title: 'New Order Placed At {{name}}',
                subtitle: 'Order Number {{number}}',
                description: 'View details and updates through your real-time online receipt',
                button_text: 'Track Order',
                track_delivery_button_text: 'Track Delivery',
            },
            email_order_completed_by_customer: {
                subject: 'Order ({{number}}) Completed by Customer',
                powered_by: 'Powered By {{name}}',
                overview: 'Order Completed Notification',
                title: 'Order Completed At {{name}}',
                subtitle: 'Order Number {{number}}',
                description: 'View details and updates your order through your dashboard or using the receipt at',
            },
        },
        totals: {
            tax: '{{name}} ({{percent}}%)',
            tax_in_prices: '{{name}} ({{percent}}%) inc. in price',
            fee: '{{name}} ({{value, currency}} + {{percent}}%)',
            fee_percent: '{{name}} ({{percent}}%)',
            fee_fixed: '{{name}}',
            delivery_fee: 'Delivery Fee',
            promo: 'Discount: {{name}} ({{value, currency}} + {{percent}}% Off)',
            promo_percent: 'Discount: {{name}} ({{percent}}%)',
            promo_fixed: 'Discount: {{name}}',
            promo_none: 'Discount: {{name}}',
            cart: 'Cart',
            tip: 'Order tip',
            total: 'Total',
        },
        status: {
            unconfirmed: 'Un-Confirmed',
            awaiting_payment: 'Awaiting Payment',
            confirmed: 'Confirmed',
            ready: 'Ready',
            on_route: 'On Route',
            complete: 'Complete',
            cancelled: 'Cancelled',
        },
        searching: {
            lalamove_search_placeholder: 'Search order by Lalamove delivery ID',
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: 'Unavailable',
                },
            },
            dish: {
                no_stock: 'Out Of Stock',
                not_available: 'Not Available',
            },
        },
    },
    admin: {
        registration: {
            register_confirmation_code_subject: 'E-Mail Confirmation Code',
            register_confirmation_code_email: 'Your email confirmation code is {{confirmation_code}} (Expires in 24 hours)',
            register_confirmation_code_email_onbehalf: 'Your email confirmation code is {{confirmation_code}} (Expires in 24 hours). This is for the email address, {{email}}.',
        },
    },
};
//# sourceMappingURL=en.js.map